export default {
	'invoice-category': 'نمط فاتورة',
	'add-invoice-category': 'إضافة نمط فاتورة',
	'use-category-for': 'استخدام النمط في',
	'set-a-default-for': 'تعيين النمط كافتراضي ل',

	'default-sales-category': 'نمط المبيع الافتراضي',
	'default-purchases-category': 'نمط الشراء الافتراضي',
	'default-sales-refund-category': 'نمط مترجعات المبيع الافتراضي',
	'default-purchases-refund-category': 'نمط مترجعات الشراء الافتراضي',

	'default-invoices-categories': 'الأنماط الافتراضية'
}